import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../shadcn/components/ui/Select";
import serviceSearch from "../../assets/home/serviceSearch.webp";
import { Button } from "../../shadcn/components/ui/Button";

export function ServiceSearch() {
  const navigate = useNavigate();
  const [selectedService, setSelectedService] = React.useState("");

  const handleSearch = () => {
    if (selectedService === "Property") {
      navigate("/property");
    } else {
      navigate("/services");
    }
  };

  return (
    <div className="relative h-full lg:h-[300px] w-full overflow-hidden rounded-xl mt-10">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${serviceSearch})`,
          filter: "brightness(0.7)",
        }}
      />
      <div className="absolute inset-0 bg-purple-900/30" />
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-white mt-5 lg:mt-0">
        <h2 className="mb-1 lg:mb-2 text-2xl lg:text-3xl font-bold">
          Search
        </h2>
        <p className="mb-8 text-lg text-gray-200">
          What are you looking for?
        </p>
        <div className="w-full max-w-4xl flex items-center justify-center gap-2">
          <div className="w-full">
            <Select onValueChange={(value) => setSelectedService(value)}>
              <label
                htmlFor="Industry"
                className="mb-1 block text-sm text-white font-semibold"
              >
                Select Service
              </label>
              <SelectTrigger className="h-10 bg-white/90 text-gray-900 mb-5 lg:mb-0">
                <SelectValue placeholder="Service" />
              </SelectTrigger>
              <SelectContent className="h-full">
                <SelectItem value="General">General Service</SelectItem>
                <SelectItem value="Transport">Transport Service</SelectItem>
                <SelectItem value="Property">Property</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex justify-center items-center md:mt-5">
            <Button 
              onClick={handleSearch}
              className="bg-purple-600 hover:bg-purple-700"
            >
              Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}